<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      :title="title"
      width="960px"
      :innerHeight="480"
      :append-to-body="true"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <el-row type="flex" justify="space-between">
        <el-upload
          class="upload-demo"
          ref="upload"
          accept=".xls,.xlsx,.xls.ttt,.xlsx.ttt"
          :limit="1"
          action=""
          :http-request="httpRequest"
          :on-remove="handleRemove"
          :headers="headers"
          :file-list="fileList"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
        >
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
<!--          <el-button style="margin-left: 10px;"
                     v-loading.fullscreen.lock="fjLoading"
                     element-loading-text="数据导入中"
                     element-loading-spinner="el-icon-loading"
                     element-loading-background="rgba(0, 0, 0, 0.8)"
                     size="small" type="success" @click="checkFormValid">上传
          </el-button>-->
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且只能上传一个</div>
        </el-upload>
      </el-row>
      <el-form :model="form" :inline="true" size="mini" style="margin-top: 10px;">
        <el-form-item label="更新说明">
          <el-input v-model="form.instruction" @input="updescBlur"></el-input>
        </el-form-item>
        <el-form-item label="SPU名称">
          <el-input v-model="form.spuName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="" @click="reset">重置</el-button>
          <el-button type="primary" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-row :gutter="10" style="width: 100%;">
        <el-col :span="10">
          <span style="color: #999;">待选列表</span>
          <el-table
            :data="tableData"
            border
            :height="320"
            style="margin-top: 10px;"
          >
            <el-table-column label="SPU编码" prop="spuCode"></el-table-column>
            <el-table-column label="SPU名称" prop="spuName"></el-table-column>
            <el-table-column label="操作" width="70px">
              <template slot-scope="scope">
                <el-button type="text"  @click="onAdd(scope.row)" v-if="tableData2.findIndex(v=>v.spuId === scope.row.spuId) === -1">添加</el-button>
                <el-button type="text" disabled v-else>已添加</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right; margin-top: 10px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="paginationOpt.pageNum"
              :page-sizes="paginationOpt.pageSizes"
              :page-size="paginationOpt.pageSize"
              layout="total, prev, pager, next"
              :total="paginationOpt.total">
            </el-pagination>
          </div>
        </el-col>
        <el-col :span="4" style="text-align: center; margin-top: 160px;">
          <el-button type="" icon="el-icon-d-arrow-left"></el-button>
          <el-button type="" icon="el-icon-d-arrow-right"></el-button>
        </el-col>
        <el-col :span="10">
          <span style="color: #999;">已选列表</span>
          <el-table
            :data="tableData2"
            border
            :height="320"
            style="margin-top: 10px;"
          >
            <el-table-column label="SPU名称" prop="spuName"></el-table-column>
            <el-table-column label="更新说明" prop="instruction">
              <template slot-scope="scope">
                <el-input v-model="scope.row.instruction"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="60px">
              <template slot-scope="scope">
                <el-button type="text"  @click="onRemove(scope.row)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </q-dialog>
  </div>
</template>

<script>
  import {getToken} from '@/utils/auth'
  import moment from 'moment'

  export default {
    model: {
      prop: 'visible',
      event: 'input'
    },
    props: ['visible'],
    data() {
      return {
        requesting:false,
        form: {},
        tableData: [],
        tableData2:[],
        paginationOpt: {
          pageSizes: [30, 60, 90],
          pageSize: 30,
          pageNum: 1,
          total: 0
        },
        headers: {
          'Authorization': getToken()
        },
        fileList: [],
        fjLoading: false
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible
        },
        set(val) {
          this.$emit('update:visible', val)
        },
      },
      title() {
        let dataType = this.$route.query.fileType;
        if (dataType == 1) {
          return 'BOM表上传'
        } else if (dataType == 2) {
          return '信息表上传'
        } else if (dataType == 3) {
          return '说辞表上传'
        }
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      updescBlur(){
        this.tableData2.forEach(item=>{
          item.instruction = this.form.instruction
        })
      },
      updateVal() {
        this.dialogVisible = false;
        if (this.isNeedRefresh) {
          this.$emit('success');
        }
        this.$emit('close');
      },
      confirm() {
        this.submitUpload()
      },
      // 上传
      handleRemove(file, fileList) {
        this.fileList = [];
        console.log(file, fileList);
      },
      httpRequest(file) {

      },
      handleSuccess(res, file) {
        if (res.code === 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        this.cancel();
        this.handleSearch();
      },
      beforeUpload(file) {
        // .xls,.xlsx,.xls.ttt,.xlsx.ttt
        let pattern = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (['xls', 'xlsx', 'xls.ttt', 'xlsx.ttt'].indexOf(pattern.toLowerCase()) === -1) {
          this.$message.error('请上传后缀名为.xls,.xlsx的附件！');
          return false;
        }
        this.fileList = [];
        this.fileList.push(file);
      },
      checkFormValid(file) {
/*        this.$refs['requestParam'].validate(valid => {
          if (valid) {
            this.submitUpload(file);
          } else {
            this.$message.error('参数校验失败！')
          }
        })*/
        this.submitUpload(file);
      },
      submitUpload(file) {
        if(this.requesting){
          return;
        }
        if (!this.fileList || this.fileList.length === 0) {
          this.$message.error('请先上传Excel附件');
          return;
        }
        this.requesting = true
        this.fjLoading = true;

        let taskDTO = null;

        taskDTO = {
          // paramMap: fields,
          spuId:this.tableData2.map(item=>item.spuId+""),
          fileType: this.$route.query.fileType, //文件类型（1bom表，2信息表，3说辞表）
          updateInstructions:this.tableData2.map(item=>item.instruction)
        };
        this.$q.newProduct.informationUpload({
          data: {
            file: this.fileList[0],
            paramJson: JSON.stringify(taskDTO)
          }
        }, true).then((res) => {
          if (res.success) {
            //this.nextUpload(res.data.fileId, this.requestParam.excuseType);
            this.dialogVisible = false;
            this.$emit('success')
          } else {
            this.$message.error(res.message);
          }
        }).finally(()=>{
          this.requesting = false
          this.fjLoading = false;
        });


/*        let fields = [
          {
            columnName: "日期",
            columnValue: this.requestParam.planTime,
            fieldName: "planTime",
            fieldValue: this.requestParam.planTime,
            relation: "planTime"
          }
        ];*/
/*        taskDTO = {
          reportName: this.form.reportName,
          appCode: "ec-pc-new",
          paramMap: []//预销计划 fields
        };

        this.$q.common.uploadFile({
          data: {
            file: this.fileList[0],
            taskDTO: JSON.stringify(taskDTO)
          }
        }).then((res) => {
          if (res.success) {
            //this.$message.success('数据导入中，请稍后');
          } else {
            this.$message.error(res.message);
          }
          this.fjLoading = false;
          this.cancel();
          this.handleSearch();
        });*/
        // this.$refs.upload.submit();
      },
      init() {
        this.loading = true;
        let formData = {
          pageSize: this.paginationOpt.pageSize,
          pageNum: this.paginationOpt.pageNum,
          filterData: {
            ...this.form,
            dataType: this.$route.query.fileType
          }
        };
        this.$q.newProduct.getSpuBomPage({data: formData})
          .then(res=>{
            this.tableData = res.data.records;
            // let spuIds = this.tableData2.map(item=>item.spuId)
            // this.tableData = this.tableData.filter(item=>!spuIds.includes(item.spuId))
            this.paginationOpt['total'] = res.data.total;
          })
          .finally(_=>{
            this.loading = false;
          })
      },
      reset() {
        this.tableData = []
        this.form.spuName = '';
        this.paginationOpt.pageNum = 1;
        this.init();
      },
      search() {
        this.paginationOpt.pageNum = 1;
        this.init();
      },
      // 分页器 pagesize
      handleSizeChange(val) {
        this.paginationOpt.pageSize = val;
        this.paginationOpt.pageNum = 1;
        this.init();
      },
      // 分页器 pageNum
      handleCurrentChange(val) {
        this.paginationOpt.pageNum = val;
        this.init();
      },
      /**
       * 添加&移除
       */
      onAdd(row) {

        row = JSON.parse(JSON.stringify(row))
        if(!this.tableData2.find(v=>v.spuId == row.spuId)) {
          this.$set(row, 'instruction', this.form.instruction);
          this.tableData2.push(row)
          // let index = this.tableData.findIndex(item=>item.spuId===row.spuId)
          // if(index>-1){
          //   this.tableData.splice(index,1)
          // }
        }
      },
      onRemove(row) {
        row = JSON.parse(JSON.stringify(row))
        if(!this.tableData.find(v=>v.spuId == row.spuId)){
          this.tableData2 = this.tableData2.filter(v=>v.spuId !== row.spuId);
          this.tableData.push(row)
        }else{
          this.tableData2 = this.tableData2.filter(v=>v.spuId !== row.spuId);
        }

      }
    }
  }
</script>

<style lang="stylus" scoped>
</style>
